import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

function createKasirAffiliates() {
  return {
    tab: 'users',
    statusFilter: 'active',
    search: '',
    searchTimer: null,
    loading: false,
    savingId: null,
    users: [],
    usersMeta: { current_page: 1, last_page: 1, total: 0 },
    commissions: [],
    commissionFilter: 'pending',

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.users = Array.isArray(cfg.affiliates) ? cfg.affiliates : [];
        this.usersMeta = cfg.affiliatesMeta || this.usersMeta;
        this.commissions = Array.isArray(cfg.commissions) ? cfg.commissions : [];
        this.tab = cfg.tab || 'users';
        this.statusFilter = cfg.statusFilter || 'active';
      } catch (e) {
        console.error('kasirAffiliates config', e);
      }
    },

    money(n) {
      return 'Rp ' + Number(n || 0).toLocaleString('id-ID');
    },

    statusBadge(status) {
      if (status === 'active' || status === 'approved' || status === 'paid') return 'badge-green';
      if (status === 'hold' || status === 'held') return 'badge-yellow';
      if (status === 'pending') return 'badge-gray';
      return 'badge-gray';
    },

    onSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.loadUsers(1), 300);
    },

    async loadUsers(page = 1) {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/affiliates/users', {
          params: {
            status: this.statusFilter === 'all' ? null : this.statusFilter,
            search: (this.search || '').trim().length >= 2 ? this.search.trim() : null,
            page,
            per_page: 30,
          },
        });
        this.users = Array.isArray(data.data) ? data.data : [];
        this.usersMeta = data.meta || this.usersMeta;
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat affiliate.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async setStatus(user, status) {
      if (!user?.id || this.savingId) return;
      const label = status === 'active' ? 'setujui (aktifkan)' : 'hold';
      if (!window.confirm(`Yakin ${label} affiliate ${user.name}?`)) return;

      this.savingId = user.id;
      try {
        const { data } = await axios.post(
          `/api/v1/kasir/engagement/affiliates/users/${user.id}/status`,
          { status }
        );
        const row = data.data || data;
        const idx = this.users.findIndex((u) => u.id === user.id);
        if (idx >= 0) {
          const merged = { ...this.users[idx], ...row };
          if (this.statusFilter !== 'all' && merged.affiliate_status !== this.statusFilter) {
            this.users.splice(idx, 1);
            this.usersMeta.total = Math.max(0, (this.usersMeta.total || 1) - 1);
          } else {
            this.users.splice(idx, 1, merged);
          }
        }
        window.toast?.(data.message || 'Status diperbarui.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal mengubah status.', 'error');
      } finally {
        this.savingId = null;
      }
    },

    async loadCommissions(page = 1) {
      this.loading = true;
      try {
        const { data } = await axios.get('/api/v1/kasir/engagement/affiliates', {
          params: {
            status: this.commissionFilter === 'all' ? null : this.commissionFilter,
            page,
            per_page: 50,
          },
        });
        this.commissions = Array.isArray(data.data) ? data.data : [];
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat komisi.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async approveCommission(c) {
      if (!c?.id || this.savingId) return;
      this.savingId = c.id;
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/affiliates/${c.id}/approve`);
        c.status = 'approved';
        window.toast?.(data.message || 'Komisi disetujui.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menyetujui.', 'error');
      } finally {
        this.savingId = null;
      }
    },

    async holdCommission(c) {
      if (!c?.id || this.savingId) return;
      if (!window.confirm('Hold komisi ini?')) return;
      this.savingId = c.id;
      try {
        const { data } = await axios.post(`/api/v1/kasir/engagement/affiliates/${c.id}/hold`);
        c.status = 'held';
        window.toast?.(data.message || 'Komisi di-hold.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal hold komisi.', 'error');
      } finally {
        this.savingId = null;
      }
    },
  };
}

Alpine.data('kasirAffiliates', createKasirAffiliates);
